import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import dataTableData from "./data/dataTableData";
import { useEffect, useState, useCallback } from "react";
import { RequestService } from "services/RequestService";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate } from "react-router-dom";
import MDAvatar from "components/MDAvatar";
import { imageUrl } from "services/RequestService";
import { Button } from "@mui/material";
import MDBadge from "components/MDBadge";
import def from "ajv/dist/vocabularies/discriminator";
import MDProgress from "components/MDProgress";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import Breadcrumbs from "examples/Breadcrumbs";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDInput from "components/MDInput";

function ProjectsDataTables() {
  const navigate = useNavigate();

  const [dataTableData2, setDataTableData] = useState(dataTableData);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [projectIdToDelete, setProjectIdToDelete] = useState(null);
  const [search, setSearch] = useState("");
  const [firstSearch, setFirstSearch] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalItems: 0
  });

  const [loading, setLoading] = useState(true);

  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }
  CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired,
  };
  const handleOpenDialog = (id) => {
    setProjectIdToDelete(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setProjectIdToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (projectIdToDelete) {
      try {
        const result = await RequestService.delete(`Project/${projectIdToDelete}`);
        if (result.status === 200) {
          toggleSnackbar();
          fetchProjects(); // Refresh data after successful deletion
        } else {
          toggleSnackbar2();
        }
      } catch (error) {
        console.error("Error deleting project:", error);
        toggleSnackbar2();
      }
      handleCloseDialog();
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      0: { color: "dark", label: "لم يبدأ" },
      1: { color: "info", label: "تحت الإنجاز" },
      2: { color: "warning", label: "معلق" },
      3: { color: "error", label: "ملغي" },
      4: { color: "success", label: "مكتمل" },
      5: { color: "info", label: "على المسار" },
      6: { color: "error", label: "متأخر" },
      7: { color: "warning", label: "متوقف" }
    };

    const config = statusConfig[status] || { color: "dark", label: "غير معروف" };

    return (
      <MDBadge
        variant="gradient"
        color={config.color}
        size="sm"
        badgeContent={config.label}
        container
      />
    );
  };

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const skip = (pagination.page - 1) * pagination.pageSize;
      const take = pagination.pageSize;

      const response = await RequestService.get(`Project?searchTerm=${search}&skip=${skip}&take=${take}`);
      if (response.data.error === false) {
        const projectData = response.data.data.map((r, index) => {
          // Convert project managers array to string
          r.projectManager = r.projectManagers.map((pm) => pm.displayName).join(", ");
          r.progress = (
            <MDBox width="8rem">
              <MDProgress
                value={r.progress}
                color={r.progress === 100 ? "success" : "info"}
                variant="gradient"
                label={true}
              />
            </MDBox>
          );
          r.projectStatusName = getStatusBadge(parseInt(r.projectStatus));
          r.actions = (
            <MDBox display="flex" alignItems="center" gap={1}>
              <MDButton
                variant="outlined"
                color="info"
                size="small"
                onClick={() => {
                  navigate(`/projectinfo?id=${r.id}`);
                }}
                startIcon={<InfoIcon />}
              >
                عرض
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => {
                  navigate(`/projects/project/edit?id=${r.id}`);
                }}
                startIcon={<EditIcon />}
              >
                تعديل
              </MDButton>
              <MDButton
                variant="outlined"
                color="error"
                size="small"
                onClick={() => handleOpenDialog(r.id)}
                startIcon={<DeleteIcon />}
              >
                حذف
              </MDButton>

            </MDBox>
          );
          r["#"] = index + 1 + (pagination.page - 1) * pagination.pageSize;
          let imagepath = imageUrl + r.imageUrl;
          r["imageUrl"] = (
            <Button
              onClick={() => {
                // Open image in new tab
                window.open(imagepath);
              }}
            >
              <MDAvatar src={imagepath} size="lg" />;
            </Button>
          );
          return r;
        });

        setDataTableData((prevState) => ({
          ...prevState,
          rows: projectData,
        }));
        setPagination({
          ...pagination,
          totalItems: response.data.totalCount
        });
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };


  const handlePageChange = (newPage) => {
    setPagination({ ...pagination, page: newPage });
  };

  const handlePageSizeChange = (newSize) => {
    setPagination({ page: 1, pageSize: newSize, totalItems: pagination.totalItems });
  };

  useEffect(() => {
    fetchProjects();
  }, [pagination.page, pagination.pageSize]);

  useEffect(() => {
    if (search || firstSearch) {
      setFirstSearch(true); {
        setPagination(prev => ({ ...prev, page: 1 }));
        const timer = setTimeout(() => {
          fetchProjects();
        }, 1000);
        return () => clearTimeout(timer);
      }
    }
  }, [search]);

  return (
    <DashboardLayout>
      <DashboardNavbar>
        {/* <Breadcrumbs
        icon="home"
        title="المشاريع"
        route={[ "projects"]}
        light={false}
        
      /> */}
      </DashboardNavbar>

      <MDSnackbar
        color="success"
        icon="notifications"
        title="تم اتمام العملية"
        content="تم اتمام العملية بنجاح"
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />

      <MDSnackbar
        color="error"
        icon="notifications"
        title="اضافة مشروع"
        content="حدث خطأ ما"
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                sx={{
                  backgroundColor: "grey.100",
                  borderBottom: "1px solid",
                  borderColor: "grey.300",
                }}
              >
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    قائمة المشاريع
                  </MDTypography>
                </MDBox>
                <MDBox width="14rem" ml="auto">
                  <MDInput
                    placeholder="بحث ..."
                    value={search}
                    fullWidth
                    onChange={({ currentTarget }) => {
                      setSearch(currentTarget.value);
                    }}
                    sx={{ margin: "0 -10px" }}
                  />
                </MDBox>
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={() => {
                    navigate("/pages/projects/project/add");
                  }}
                  startIcon={<AddIcon />}
                >
                  إضافة مشروع
                </MDButton>
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                sx={{
                  backgroundColor: "grey.100",
                  borderBottom: "1px solid",
                  borderColor: "grey.300",
                }}
              >
                <MDBox>
                  <MDBox mt={1}>
                    <MDTypography variant="button" color="text" fontWeight="regular">
                      حالة المشاريع:
                    </MDTypography>
                    <MDBox
                      display="flex"
                      gap={1}
                      mt={0.5}
                      sx={{
                        flexWrap: { xs: "wrap", md: "nowrap" }, // Wrap for small screens, no wrap for larger screens
                        justifyContent: "flex-start", // Center items on mobile
                      }}
                    >
                      {getStatusBadge(0)}
                      {getStatusBadge(1)}
                      {getStatusBadge(2)}
                      {getStatusBadge(3)}
                      {getStatusBadge(4)}
                      {getStatusBadge(5)}
                      {getStatusBadge(6)}
                      {getStatusBadge(7)}
                    </MDBox>

                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={dataTableData2}
                  isSorted={true}
                  entriesPerPage={{
                    defaultValue: pagination.pageSize,
                    entries: [5, 10, 15, 20, 25],
                    onChange: handlePageSizeChange
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  loading={loading}
                  pagination={{
                    variant: "gradient",
                    color: "info",
                    page: pagination.page,
                    totalPages: Math.ceil(pagination.totalItems / pagination.pageSize),
                    totalItems: pagination.totalItems,
                    onPageChange: handlePageChange
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="confirm-delete-dialog-title"
      >
        <DialogTitle id="confirm-delete-dialog-title">تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>سيتم حذف بيانات هذا الحقل بشكل نهائي. هل أنت متأكد؟</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleConfirmDelete} color="error">
            نعم
          </MDButton>
          <MDButton onClick={handleCloseDialog} color="secondary">
            لا
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ProjectsDataTables;
